export default __webpack_public_path__ + "static/media/941.067a2866.png";